module.exports = __webpack_public_path__ + "assets/img/banner.0725ae14.png";